module.exports = __webpack_public_path__ + "img/motor_no26.0f568c56.jpg";